import React, { useContext, useEffect, useState } from 'react'
import { Train_Props } from './interface'
import { TrainWrapper } from './TrainStyles'
import Trapezoid from './Trapezoid'
import { MyContext } from '../../../context/createContext'

export default function Train({
  trainInfo,
  handleAbove,
  anim,
  handleRoundId,
  handlePopup,
  sendSocketMessage,
  betId,
  audio,
}: Train_Props) {
  const { context } = useContext(MyContext)
  const { globalSocketMessages } = context

  return (
    <>
      <TrainWrapper>
        <Trapezoid
          betId={betId}
          trainInfo={trainInfo}
          handleAbove={handleAbove}
          requestBetReply={globalSocketMessages.requestBetReply}
          handleRoundId={handleRoundId}
          handlePopup={handlePopup}
          sendSocketMessage={sendSocketMessage}
          anim={anim}
          audio={audio}
        />
      </TrainWrapper>
    </>
  )
}
